<ul class="bc-workitem-titles-list bc-text-chat-workitems">
  <li class="outer-item" [@taskItemAnimation] [attr.data-automation-id]="'workitem-text-chat-list'"
    [attr.data-workitem-id]="workitem.id" *ngFor="let workitem of textChatWorkItemList; trackBy: trackByWorkItemId">

    <div class="item traversable-list-item"
         [ngClass]="generateWorkitemClass(workitem)"
         [attr.tabindex]="0"
         (keydown)="onWorkItemKeydown($event, workitem)"
         (click)="selectWorkItem(workitem)">
      <div class="item-inner">
        <div *ngIf="!workitem.isFacebook()" class="visitor-avatar">
          <svg-avatar id="{{ workitem.avatarThemeId }}"></svg-avatar>
        </div>
        <div *ngIf="workitem.isFacebook() || workitem.isAsyncMessage()" class="visitor-avatar">
          <img class="text-chat-icon" [src]="workitem.ImageUrl" *ngIf="workitem.ImageUrl" />
          <svg-avatar id="missing" id="{{ workitem.avatarThemeId }}" *ngIf="!workitem.ImageUrl"></svg-avatar>
        </div>

        <workitem-activity-indicator [unansweredMessageCount]="workitem.unansweredMessages"
          [showSecondsRemaining]="workitem.showSecondsRemaining"
          [secondsRemainingDisplay]="workitem.secondsRemainingDisplay" [forceDisableRedDots]="workitem.Ended"
          [showWrapUpIndicator]="true"></workitem-activity-indicator>

        <div class="visitor-name">
          {{ workitem.UserDisplayName }}
        </div>

        <div class="folder-wrapper">
          <div class="visitor-folder department-folder">
            <svg-icon icon="folder"></svg-icon>
            <span>{{ workitem.departmentFolder }}</span>
          </div>
        </div>

        <div class="messages">
          <div *ngFor="let message of workitem.messages | slice: (workitem.Ended || '') && -1">
            <span [ngClass]="generateLastMessagesClass(message)"
              [innerHTML]="message.shortText | appOperatorChatMessageFormat"></span>
          </div>
        </div>
        <div *ngIf="workitem.isSms()" class="text-chat-type-icon">
          <svg-icon icon="sms"></svg-icon>
        </div>
        <div *ngIf="workitem.isFacebook()" class="text-chat-type-icon">
          <svg-icon icon="message"></svg-icon>
        </div>
        <div *ngIf="workitem.isAsyncMessage()" class="text-chat-type-icon">
          <svg-icon icon="{{workitem.IconID}}"></svg-icon>
        </div>
      </div>
    </div>

    <app-work-item-interaction *ngIf="isWorkItemAcceptable(workitem)"
                               (accept)="acceptButtonClicked(workitem, $event)">
    </app-work-item-interaction>
  </li>
</ul>
